var map = {
	"./default_avatar_0.png": 181,
	"./default_avatar_1.png": 182,
	"./default_avatar_10.png": 183,
	"./default_avatar_11.png": 184,
	"./default_avatar_12.png": 185,
	"./default_avatar_13.png": 186,
	"./default_avatar_14.png": 187,
	"./default_avatar_15.png": 188,
	"./default_avatar_16.png": 189,
	"./default_avatar_17.png": 190,
	"./default_avatar_2.png": 191,
	"./default_avatar_3.png": 192,
	"./default_avatar_4.png": 193,
	"./default_avatar_5.png": 194,
	"./default_avatar_6.png": 195,
	"./default_avatar_7.png": 196,
	"./default_avatar_8.png": 197,
	"./default_avatar_9.png": 198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;